<template>
  <div class="min-h-screen bg-cream flex flex-col">
    <!-- Header: logo + logout -->
    <header
      class="sticky top-0 z-30 bg-white shadow-sm border-b border-gray-200"
    >
      <div class="flex items-center justify-between h-16 sm:h-18 px-4 sm:px-6">
        <router-link to="/app" class="flex items-center shrink-0">
          <img
            src="@/assets/images/logo.png"
            alt="Educ360"
            class="h-10 sm:h-10 w-auto object-contain"
            @error="$event.target.src = require('@/assets/images/favicon.png')"
          />
        </router-link>
        <button
          type="button"
          @click="handleLogout"
          class="flex items-center gap-2 px-3 py-2 text-red-600 rounded-lg hover:bg-red-50 transition-colors text-sm font-medium"
        >
          <i class="fas fa-sign-out-alt"></i>
          <span class="hidden sm:inline">Déconnexion</span>
        </button>
      </div>
    </header>

    <main class="flex-1 px-4 sm:px-6 py-6 sm:py-8 max-w-6xl mx-auto w-full">
      <slot />
    </main>
  </div>
</template>

<script>
export default {
  name: "MainLayout",
  methods: {
    handleLogout() {
      this.$store.dispatch("logout");
      this.$router.push({ name: "Login" });
    },
  },
};
</script>
